import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Card} from 'ktm-ui';

interface IdsDivision {
    Id:string;
    Policy_Id:string;
    Name:string;
    Description:string;
    IsActive:boolean;
};

export default KTMScreen({name:"enroll.division.edit"}, class extends React.Component<{division_id:string}> {

    data:{
        dsDivision:IdsDivision;
    }

    // Store original data for comparison
    originalData: IdsDivision | null = null;

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsDivision";
        await KTMApi.start(screen,{
            "@division_id":this.props.division_id,
        });
        screen.title = "Edit division";
        // Store a copy of the original data
        this.originalData = { ...this.data.dsDivision };
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw("details")}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Edit division"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        var isDisabled = this.data.dsDivision.Name == null ||
        this.data.dsDivision.Name == "" ||
        this.data.dsDivision.Description == null ||
        this.data.dsDivision.Description == "";

        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary" disable={isDisabled}/>
            </Dialog.Footer>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Display field={field("Name")}/>
                <Display field={field("Description")}/>
                {/* <Display field={field("IsActive")}/> */}
            </Card>
        );
    }

    getChangedFields(originalData, updatedData) {
        if (!originalData) return {};
  
        const changes = {};
        for (const key in updatedData) {
          if (updatedData[key] !== originalData[key]) {
            changes[key] = {
              oldValue:
                originalData[key] !== undefined ? originalData[key] : "N/A",
              newValue: updatedData[key] !== undefined ? updatedData[key] : "N/A",
            };
          }
        }
        return changes;
    }

    async submit({screen}:ActionEvent){
        // Track changes
        const changes = this.getChangedFields(
            this.originalData,
            this.data.dsDivision
        );

        const logDetails = Object.entries(changes)
            .map(([key, value]) => {
            const change = value as { oldValue: any; newValue: any };
            return `${key}: ${change.oldValue} → ${change.newValue}`;
            })
            .join(" | ");

        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note: logDetails,
            Action: "Policy Edit Division",
            PolicyId: this.data.dsDivision.Policy_Id,
            }),
        };

        await KTMApi.action(screen,"submit",{
            "@division_id":this.props.division_id,
            "@dsData.Name":this.data.dsDivision.Name,
            "@dsData.Description":this.data.dsDivision.Name,
        }).then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        });
        screen.close({"continue":true});
    }
});
